import React from "react";
import { motion } from "framer-motion";

export const Marquee = ({ text = "LESS IS TRANSFORMATION", repeat = 6, duration = 21 }) => {
  const items = Array.from({ length: repeat });
  const Group = ({ ariaHidden }) => (
    <div className="flex shrink-0" aria-hidden={ariaHidden}>
      {items.map((_, i) => (
        <span
          key={i}
          className="font-serif text-5xl md:text-7xl font-light tracking-tight text-transparent px-8"
          style={{ WebkitTextStroke: "1px rgba(198,168,124,0.35)" }}
        >
          {text}{" "}
          <span className="text-kenosis-gold/40" style={{ WebkitTextStroke: "0" }}>
            &#10022;
          </span>
        </span>
      ))}
    </div>
  );

  return (
    <div className="relative w-full overflow-hidden py-10 select-none border-y border-white/10">
      <motion.div
        className="flex whitespace-nowrap will-change-transform"
        animate={{ x: ["0%", "-50%"] }}
        transition={{ duration, ease: "linear", repeat: Infinity, repeatType: "loop" }}
      >
        <Group ariaHidden={false} />
        <Group ariaHidden={true} />
      </motion.div>
    </div>
  );
};
